import { render, staticRenderFns } from "./ModelLayout.vue?vue&type=template&id=32f709de&scoped=true"
import script from "./ModelLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModelLayout.vue?vue&type=style&index=0&id=32f709de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f709de",
  null
  
)

export default component.exports